import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtributeCopiiComponent } from './atribute-copii.component';
import { AddAtributeCopiiComponent } from './add-atribute-copii/add-atribute-copii.component';
import { EditAtributeCopiiComponent } from './edit-atribute-copii/edit-atribute-copii.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        AtributeCopiiComponent,
        AddAtributeCopiiComponent,
        EditAtributeCopiiComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [AtributeCopiiComponent]
})
export class AtributeCopiiModule { }
